import axios, { AxiosInstance, AxiosRequestConfig } from "axios";

export abstract class BaseAxios {
  private axiosInstance: AxiosInstance;
  protected authtoken: string | null = null;

  constructor(baseURL: string) {
    this.authtoken = localStorage.getItem("authToken") || null;
    this.axiosInstance = axios.create({
      baseURL,
      // Add other default configurations here
    });
  }

  protected async get<T>(url: string, config?: AxiosRequestConfig): Promise<T> {
    const response = await this.axiosInstance.get<T>(url, config);
    return response.data;
  }

  protected async post<T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const response = await this.axiosInstance.post<T>(url, data, config);
    return response.data;
  }

  protected async delete<T>(
    url: string,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const response = await this.axiosInstance.delete<T>(url, config);
    return response.data;
  }

  protected async patch<T>(
    url: string,
    data: any,
    config?: AxiosRequestConfig
  ): Promise<T> {
    const response = await this.axiosInstance.patch<T>(url, data, config);
    return response.data;
  }

  // Add other HTTP methods (put, delete, etc.) as needed
}
